module.exports = __webpack_public_path__ + "img/avatar-test.327f8346.jpg";